import React from 'react'

const Thumb = ({ src }) => {
    const noimg = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/no_item_img.jpg`

    const errImg = (e) => {
        e.target.src = noimg
    }

    return (
        <img src={src} alt='' onError={errImg} />
    )
}

export default Thumb



// WEBPACK FOOTER //
// ./src/estimate_list/components/stdpc/thumb.js